import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  count: number;
  maxCount: number;
}

function CharCount({ count, maxCount }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {count}/{maxCount}
    </div>
  );
}

const useStyles = makeStyles(() => ({
  root: { height: 18, display: 'flex', justifyContent: 'flex-end' },
}));

export default CharCount;
